export default async (url: URL, sectionId: string, updateUrl: boolean) => {
  const urlToFetch = url;

  if (updateUrl) {
    window.history.replaceState({}, '', urlToFetch);
  }

  urlToFetch.searchParams.set('section_id', sectionId);

  const response = await fetch(urlToFetch);
  const markup = await response.text();

  const container = document.createElement('div');
  container.innerHTML = markup;

  return container;
};
